import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface AppSettings {
  apiUrl: string;
  publicKey: string;
  saltKey: string;
  projectName: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfig {
  settings: AppSettings = {
    apiUrl: environment.API_URL,
    publicKey: environment.PUBLIC_KEY,
    saltKey: environment.SALT_KEY,
    projectName: environment.PROJECT_NAME,
  };
}
